export const WHITESPACE_REGEX: RegExp = /\s/g
export const PUNCTUATION_REGEX: RegExp = /^[@#$%^&*()\-+_=/\[\]{}:;|~<>"']+$/g
export const TERMINATION_REGEX: RegExp = /^[.,?!]+$/g
export const ALPHA_REGEX: RegExp = /[^a-zA-Z]/g
export const NUMERIC_REGEX: RegExp = /[^0-9]/g
